(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('DocumentDeleteController',DocumentDeleteController);

    DocumentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Document'];

    function DocumentDeleteController($uibModalInstance, entity, Document) {
        var vm = this;

        vm.document = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.externalRecipients = [];
        vm.recipientsCheckFailed = false;
        vm.recipientsLoading = true;

        // Deleting the document also deletes its external access hashes, so any link already
        // emailed stops working for good. Warn about the recipients that hold one.
        // This check must fail CLOSED: if we cannot tell, an empty dialog would look exactly
        // like "never emailed" at the moment the operator is about to do something irreversible.
        Document.externalAccessRecipients(
            { ids: entity.id },
            function (result) {
                if (result && angular.isArray(result.emails)) {
                    vm.externalRecipients = result.emails;
                } else {
                    vm.recipientsCheckFailed = true;
                }
                vm.recipientsLoading = false;
            },
            function () {
                vm.recipientsCheckFailed = true;
                vm.recipientsLoading = false;
            }
        );

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Document.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
